import { render, staticRenderFns } from "./GlobalTutorialModal.vue?vue&type=template&id=1786a47a&"
import script from "./GlobalTutorialModal.vue?vue&type=script&lang=js&"
export * from "./GlobalTutorialModal.vue?vue&type=script&lang=js&"
import style0 from "./GlobalTutorialModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports